import { Container, Row, Col, Accordion } from "react-bootstrap";
import { motion } from "framer-motion";
import "./aboutDoctor.css";
import CustomNavbar from "../components/Navbar/Navbar";
import Footer from "../components/Footer/Footer";

function AboutDoctorTrupti() {
  return (
    <>
    <CustomNavbar />
    <section className="about-doctor py-5">

      <Container>

        {/* TOP HEADING */}
        <motion.div
          className="text-center mb-5"
          initial={{ opacity: 0, y: -40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
        >
          <h2 className="section-title">
            ABOUT DR. TRUPTI SUDARSHAN HAMBIRE
          </h2>
        </motion.div>

        {/* ROW 1 */}

        <Row className="align-items-center doctor-top">

          {/* IMAGE */}

          <Col lg={4} md={5} className="text-center mb-4">
            <motion.img
              src="/drTrupti.jpeg"
              alt="Dr Trupti Hambire"
              className="doctor-img"
              initial={{ opacity: 0, x: -80 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
            />
          </Col>

          {/* INFO */}

          <Col lg={8} md={7}>

            <motion.div
              initial={{ opacity: 0, x: 80 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
            >

              <h3 className="doctor-name">Dr. Trupti Hambire</h3>

              <p className="doctor-degree">
                BAMS | Cosmetologist | Ayurvedacharya
              </p>

              <ul className="doctor-details">
                <li><strong>Reg No:</strong> I-98502-A</li>
                <li><strong>Experience:</strong> 5+ Years</li>
                <li><strong>Clinic:</strong> Dr Trupti's Health And Beauty Clinic</li>
                <li><strong>Email:</strong> drtrupticlinic@gmail.com</li>
                <li><strong>Phone:</strong> +91 8007743569</li>
              </ul>

              <p className="doctor-desc">
                Dr. Trupti Hambire is an experienced Cosmetologist specializing
                in skin, hair treatments. She provides advanced
                treatments for acne, pigmentation, hair loss and anti-aging
                procedures using modern techniques.
              </p>

            </motion.div>

          </Col>

        </Row>

        {/* ACCORDION */}

        <Row className="mt-5">
          <Col>

            <motion.div
              initial={{ opacity: 0, y: 80 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
            >

              <Accordion defaultActiveKey="0" className="doctor-accordion">

                <Accordion.Item eventKey="0">
                  <Accordion.Header>Education</Accordion.Header>
                  <Accordion.Body>
                    BAMS – Shree Annasaheb Dange Ayurveda Medical College Ashtami, Sangli. <br/>
                    PGDCC - I2CAN Pune.
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="1">
                  <Accordion.Header>Achievements</Accordion.Header>
                  <Accordion.Body>
                    Best Cosmetologist Award 2025. <br/>
                    Member of Indian Association of Cosmetologist.
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="2">
                  <Accordion.Header>Work Experience</Accordion.Header>
                  <Accordion.Body>
                    Sub District Hospital Satara. <br/>
                    Dinananth Mangeshkar Hospital, Erandwane,pune. <br/>
                    Shashwat Hospital Kothrud pune. <br/>
                    Sarvadnya Multispeciality Hospital Moshi.
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="4">
                  <Accordion.Header>Area of Interest</Accordion.Header>
                  <Accordion.Body>
                    Acne Treatment <br/>
                    Hair Loss Treatment <br/>
                    Laser Skin Procedures <br/>
                    Anti-Aging Therapy
                  </Accordion.Body>
                </Accordion.Item>

              </Accordion>

            </motion.div>

          </Col>
        </Row>

      </Container>

    </section>

    <Footer />
    </>
  );
}

export default AboutDoctorTrupti;